import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { Checkbox, FormGroup, FormControlLabel, Tooltip, Typography } from '@mui/material';
import { getUserList, updateUserStatus } from '../actions/admin.actions';

const ApplicationListing = () => {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPage, setTotalPage] = useState(1);
  const [users, setUsers] = useState([]);
  const [searchPlaceholder, setSearchPlaceholder] = useState('EMP ID');
  const [searchBy, setSearchBy] = useState('empid');
  const [searchValue, setSearchValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [updatingStatus, setUpdatingStatus] = useState(null);

  const perPageChange = (e) => {
    setPerPage(e.target.value);
    setPage(1);
  }

  const changePage = (p) => {
    if (p < 1) p = 1;
    if (p > totalPage) p = totalPage;
    setPage(p);
  }

  const handleSearchInput = (e) => {
    setSearchValue(e.target.value);
  }

  const handleColumnClick = (type) => {
    let placeholder = '';
    switch (type) {
      case 'empid':
        placeholder = 'EMP ID';
        break;
      case 'name':
        placeholder = 'Name';
        break;
      default:
        placeholder = 'EMP ID';
        break;
    }
    setSearchPlaceholder(placeholder);
    setSearchBy(type);
  }

  useEffect(() => {
    loadUsers();
  }, [page, perPage, searchValue]);

  const loadUsers = (showLoader) => {
    if(showLoader !== false){
      setLoading(true);
    }
    getUserList({ page: page, perPage: perPage, search_by: searchBy, search: searchValue })
      .then((res) => {
        if (res.data.status) {
          setUsers(res.data.data.users);
          setTotalCount(res.data.data.totalCount);
          setTotalPage(res.data.data.totalPage);
        }
        setLoading(false);
        setUpdatingStatus(null);
      }).catch((err) => { });
  }

  const updateStatus = (id, status) => {
    setUpdatingStatus(id);
    updateUserStatus({ id: id, status: status })
    .then((res) => {
      if (res.data.status) {
        loadUsers(false);
      }
      
    }).catch((err) => { });
  }

  return (
    <>
      <div className='regis-main-sec forms-main-sec user-content' >
        <div className='container-fluid mt-5'>
          <div className='row'>
            <div className='col-md-12 mt-4 mb-4'>
              <div className='regis-head forms-heading-sec'>
                <h2 className='text-start ms-2'>User Listing</h2>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12'>
              <div className='club-sec application-sec'>
                <div className='container-fluid'>
                  <div className='club-inner-secss form-table-sec table-section-route table-form appl-sec'>
                    <div className='row'>
                      <div className="col-sm-3 mt-3" >
                        <div className="sorting-e-form">
                          <label style={{ width: '100%' }}>
                            <span style={{ marginRight: '10px', fontSize: '14px' }}>Show entries</span>
                            <select className='selee-sort' onChange={perPageChange} value={perPage}>
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                              <option value={100}>100</option>
                            </select>
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 margin-ns-pad">
                        {users.length > 0 && (
                          <p className="total-user right-user tot-app">Total Users {totalCount}</p>
                        )}
                        <div className='filtr-sec'>
                          <div className='select-sec-newss'>
                            <select>
                              <option>Liberty High School</option>
                              <option>Liberty High School</option>
                              <option>Liberty High School</option>
                            </select>
                          </div>
                          <div className='text-fld-sec appl_list mt-5'>
                            <input type="text" placeholder={searchPlaceholder} onChange={handleSearchInput} value={searchValue} className='inpt-sec' />
                            <span className='search-sec'><SearchIcon /></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-12'>
                        <table className="table table-bordered">
                          <thead className="thead-light thead-travel thead-form">
                            <tr>
                              <th className='std-id-width' onClick={() => handleColumnClick('empid')} role='button'>EMP ID</th>
                              <th className='std-name-width' onClick={() => handleColumnClick('name')} role='button'>Name</th>
                              <th className='loc-width' onClick={() => handleColumnClick('user_type')} role='button'>User Type</th>
                              <th className='grade-width' onClick={() => handleColumnClick('location')} role='button'>Location</th>
                              <th className='stts-width'>Status</th>
                              <th className='stts-width'>Action</th>
                            </tr>
                          </thead>
                          <tbody className='tbody-light tbody-form'>
                            {loading ? (
                              <tr>
                                <td colSpan={6}>
                                  <div className="spinner-border" role="status" style={{ width: "1rem", height: "1rem", marginLeft: "6px" }}></div>
                                </td>
                              </tr>
                            ) : (
                              users.length > 0 ? (
                                users.map((item, index) => (
                                  <tr key={index}>
                                    <td>{item.empid}</td>
                                    <td>{item.name} {item.last_name}</td>
                                    <td>{item.type_display}</td>
                                    <td>{item.location}</td>
                                    <td>
                                      {
                                        updatingStatus == item.id ? (
                                          <div className="spinner-border" role="status" style={{ width: "1rem", height: "1rem", marginLeft: "6px" }}></div>
                                        ) : (
                                          <div class="switch-wrapper line-switch">
                                            <input type="checkbox" id={`switchBox` + item.id} class="switch-input" onClick={(e) => updateStatus(item.id, item.status == 'inactive' ? 'active' : 'inactive')}
                                              checked={item.status == 'active' ? true : false}
                                            />
                                            <label for={`switchBox` + item.id} class="switch-label"></label>
                                          </div>
                                        )
                                      }
                                    </td>
                                    <td>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={6}>No Data Found</td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                        {totalPage > 1 && (
                          <div className="pagination-sec" style={{ boxShadow: '#ff98001a 0px 7px 16px 0px', width: "auto", float: "right", border: "1px solid #FF9800", marginTop: "2px", marginRight: "5px", height: "40px" }}>
                            <div style={{ float: "left", padding: "0px 0px", color: "#0B5CAB", fontSize: "14px", width: '100%', position: 'relative', display: 'inline-flex' }}>
                              <div className="" style={{ backgroundColor: '#FF9800', color: '#ffffff' }}>
                                <p style={{ marginBottom: '0px', padding: '9px 10px' }}>Page {page} of {totalPage}</p>
                              </div>
                              <div className="pagin-sec">
                                <i className="fa-solid fa-angle-left" style={{ float: "left", marginTop: "10px", marginLeft: "10px", cursor: "pointer", fontSize: '18px', color: '#727272' }} onClick={() => changePage(page - 1)}></i>
                                <span className="go-sec" style={{ float: "left", fontSize: "15px", marginTop: "10px", marginLeft: "10px", marginRight: '10px', color: "#626262" }}>Go to </span>
                                <input type="number"
                                  value={page}
                                  onChange={(e) => {
                                    !isNaN(parseInt(e.target.value)) && parseInt(e.target.value) > 0 ? changePage(parseInt(e.target.value)) : changePage(1)
                                  }}
                                  style={{ paddingTop: '4px', color: "rgb(0, 23, 55)", margin: "8px 6px 0px 4px", fontSize: "14px", width: "34px", height: '34px', float: "left", textAlign: "center", border: "1px solid #727272", borderRadius: "3px", outline: "none" }}
                                />
                                <i className="fa-solid fa-angle-right" style={{ float: "left", marginTop: "10px", marginRight: '6px', marginLeft: "5px", cursor: "pointer", fontSize: '20px', color: '#727272' }} onClick={() => changePage(page + 1)}></i>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ApplicationListing;
